module.exports = __webpack_public_path__ + "static/media/add.d0fd59f3.svg";